module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2'), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Catalog")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "{FILTER": "Chroma(Color = #FFFFFF)}"
    },
    attrs: {
      "src": "https://docs.google.com/document/d/e/2PACX-1vS7jFugbCHWqbkhQ2CpC-YHz6cNuHBylH_cMwO5KBgZheJYZgtz2zNVrvXBOnKFkRSlMujzmkQFMVpg/pub?embedded=true",
      "width": "100%",
      "height": "1500",
      "frameborder": "0",
      "allowtransparency": "true",
      "scrolling": "auto"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ccc19b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalog.vue
// module id = 335
// module chunks = 0